// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * # Layer Panel Styles
 *
 * Styling for the layer visibility panel in the IDE sidebar.
 * Uses IDE CSS variables for consistency with the rest of the app.
 */

/* Layer row: compact clickable row with color swatch */
.layer-panel-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 6px;
  margin-left: 4px;
  cursor: pointer;
  border-radius: 3px;
  transition: background-color 0.1s;
  user-select: none;
}

.layer-panel-row:hover {
  background-color: var(--color-ide-surface-2);
}

.layer-panel-row.layer-hidden {
  opacity: 0.4;
}

.layer-panel-row.layer-hidden .layer-panel-name {
  text-decoration: line-through;
}

/* Color swatch */
.layer-panel-swatch {
  width: 14px;
  height: 12px;
  border: 1px solid var(--color-ide-border);
  border-radius: 2px;
  flex-shrink: 0;
  box-sizing: border-box;
}

/* Layer name */
.layer-panel-name {
  flex: 1;
  font-size: 11px;
  color: var(--color-ide-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Layer number */
.layer-panel-number {
  font-size: 10px;
  color: var(--color-ide-text-muted);
  font-family: "Courier New", monospace;
  flex-shrink: 0;
}

/* Category header */
.layer-panel-category {
  font-size: 10px;
  font-weight: 600;
  text-transform: capitalize;
  color: var(--color-ide-text-dim);
  padding: 6px 6px 2px;
  letter-spacing: 0.3px;
}

/* Show All button */
.layer-panel-show-all-btn {
  font-size: 10px;
  color: var(--color-ide-text-muted);
  background: none;
  border: 1px solid var(--color-ide-border);
  border-radius: 3px;
  padding: 2px 8px;
  cursor: pointer;
  transition: background-color 0.1s, color 0.1s;
}

.layer-panel-show-all-btn:hover {
  background-color: var(--color-ide-surface-2);
  color: var(--color-ide-text);
}

/* Display Options section */
.layer-panel-display-options {
  border-top: 1px solid var(--color-ide-border);
  padding: 4px 0;
  margin-top: 4px;
}

/* Checkbox row */
.layer-panel-checkbox-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 6px;
  margin-left: 4px;
  cursor: pointer;
  border-radius: 3px;
  transition: background-color 0.1s;
  user-select: none;
}

.layer-panel-checkbox-row:hover {
  background-color: var(--color-ide-surface-2);
}

.layer-panel-checkbox-row input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
  accent-color: var(--color-ide-text-muted);
}

.layer-panel-checkbox-label {
  font-size: 11px;
  color: var(--color-ide-text);
}

/*
 * Two-column layout: parent visibility toggle on the left, "Select X" toggle on
 * the right. Sub-toggles (indented) only appear in the left column.
 *
 * Grid columns are equal-width so the right column lines up across rows even
 * when some parents have no sub-items below them.
 */
.layer-panel-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 4px;
  row-gap: 0;
  padding: 2px 0;
}

/* A category block spans both grid columns so its inner two-column row + the
 * indented sub-items stack vertically beneath each other. */
.layer-panel-category-block {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 4px;
  padding-bottom: 4px;
}

/* Sub-rows live under the parent in the left column only. */
.layer-panel-sub-rows {
  grid-column: 1 / 2;
  display: flex;
  flex-direction: column;
}

/* Indent sub-toggles under the parent visibility toggle so the relationship is
 * visually obvious. The 14px matches the parent's checkbox + gap so the
 * sub-label sits flush with the parent label. */
.layer-panel-checkbox-row.layer-panel-sub-row {
  margin-left: 22px;
}

/* Disabled checkbox row — sub-toggles when their parent visibility is off. */
.layer-panel-checkbox-row.is-disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.layer-panel-checkbox-row.is-disabled input[type="checkbox"] {
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/LayerPanel/layerPanel.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF,uDAAuD;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,OAAO;EACP,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,kCAAkC;EAClC,qCAAqC;EACrC,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA,4BAA4B;AAC5B;EACE,6CAA6C;EAC7C,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;;;;;EAME;AACF;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;4DAC4D;AAC5D;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;gDAEgD;AAChD;EACE,iBAAiB;AACnB;;AAEA,6EAA6E;AAC7E;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/*\n * # Layer Panel Styles\n *\n * Styling for the layer visibility panel in the IDE sidebar.\n * Uses IDE CSS variables for consistency with the rest of the app.\n */\n\n/* Layer row: compact clickable row with color swatch */\n.layer-panel-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 6px;\n  margin-left: 4px;\n  cursor: pointer;\n  border-radius: 3px;\n  transition: background-color 0.1s;\n  user-select: none;\n}\n\n.layer-panel-row:hover {\n  background-color: var(--color-ide-surface-2);\n}\n\n.layer-panel-row.layer-hidden {\n  opacity: 0.4;\n}\n\n.layer-panel-row.layer-hidden .layer-panel-name {\n  text-decoration: line-through;\n}\n\n/* Color swatch */\n.layer-panel-swatch {\n  width: 14px;\n  height: 12px;\n  border: 1px solid var(--color-ide-border);\n  border-radius: 2px;\n  flex-shrink: 0;\n  box-sizing: border-box;\n}\n\n/* Layer name */\n.layer-panel-name {\n  flex: 1;\n  font-size: 11px;\n  color: var(--color-ide-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Layer number */\n.layer-panel-number {\n  font-size: 10px;\n  color: var(--color-ide-text-muted);\n  font-family: \"Courier New\", monospace;\n  flex-shrink: 0;\n}\n\n/* Category header */\n.layer-panel-category {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: capitalize;\n  color: var(--color-ide-text-dim);\n  padding: 6px 6px 2px;\n  letter-spacing: 0.3px;\n}\n\n/* Show All button */\n.layer-panel-show-all-btn {\n  font-size: 10px;\n  color: var(--color-ide-text-muted);\n  background: none;\n  border: 1px solid var(--color-ide-border);\n  border-radius: 3px;\n  padding: 2px 8px;\n  cursor: pointer;\n  transition: background-color 0.1s, color 0.1s;\n}\n\n.layer-panel-show-all-btn:hover {\n  background-color: var(--color-ide-surface-2);\n  color: var(--color-ide-text);\n}\n\n/* Display Options section */\n.layer-panel-display-options {\n  border-top: 1px solid var(--color-ide-border);\n  padding: 4px 0;\n  margin-top: 4px;\n}\n\n/* Checkbox row */\n.layer-panel-checkbox-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 6px;\n  margin-left: 4px;\n  cursor: pointer;\n  border-radius: 3px;\n  transition: background-color 0.1s;\n  user-select: none;\n}\n\n.layer-panel-checkbox-row:hover {\n  background-color: var(--color-ide-surface-2);\n}\n\n.layer-panel-checkbox-row input[type=\"checkbox\"] {\n  margin: 0;\n  cursor: pointer;\n  accent-color: var(--color-ide-text-muted);\n}\n\n.layer-panel-checkbox-label {\n  font-size: 11px;\n  color: var(--color-ide-text);\n}\n\n/*\n * Two-column layout: parent visibility toggle on the left, \"Select X\" toggle on\n * the right. Sub-toggles (indented) only appear in the left column.\n *\n * Grid columns are equal-width so the right column lines up across rows even\n * when some parents have no sub-items below them.\n */\n.layer-panel-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 4px;\n  row-gap: 0;\n  padding: 2px 0;\n}\n\n/* A category block spans both grid columns so its inner two-column row + the\n * indented sub-items stack vertically beneath each other. */\n.layer-panel-category-block {\n  grid-column: 1 / -1;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 4px;\n  padding-bottom: 4px;\n}\n\n/* Sub-rows live under the parent in the left column only. */\n.layer-panel-sub-rows {\n  grid-column: 1 / 2;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Indent sub-toggles under the parent visibility toggle so the relationship is\n * visually obvious. The 14px matches the parent's checkbox + gap so the\n * sub-label sits flush with the parent label. */\n.layer-panel-checkbox-row.layer-panel-sub-row {\n  margin-left: 22px;\n}\n\n/* Disabled checkbox row — sub-toggles when their parent visibility is off. */\n.layer-panel-checkbox-row.is-disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.layer-panel-checkbox-row.is-disabled input[type=\"checkbox\"] {\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
